module.exports = __webpack_public_path__ + "f9c48cf3246f6c54aaa3c4cf3d62427b.pdf";